// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Srs3","selected":"Chip_selected__OFi_h"};